<template>
    <div class="badge-contianer">
        <slot />
        <div class="badge-label">{{ label }}</div>
    </div>
</template>

<script>
export default {
    name: "BadgePill",
    props: {
        label: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss">
.badge-contianer {
    position: relative;

    .badge-label {
        position: absolute;
        top: -10px;
        right: -10px;
        background-color: #000;
        color: #fff;
        border-radius: 50%;
        padding: 2px 5px;
        font-size: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
}
</style>